import { FormattedMessage } from 'react-intl';

import { HiringGoalsContent } from '@/components/pages/channels/hiring-goals-modal/hiring-goals-content';
import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';

interface HiringGoalModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

function HiringGoalModal({ open, onOpenChange }: HiringGoalModalProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="min-w-[550px]">
        <SheetHeader>
          <SheetTitle>
            <FormattedMessage
              defaultMessage="Hiring goals"
              description="Sheet title: list and status of hire-by goals for this role"
            />
          </SheetTitle>
        </SheetHeader>

        <HiringGoalsContent onClose={() => onOpenChange(false)} />

        <SheetFooter>
          <Button
            variant="secondary"
            type="button"
            onClick={() => onOpenChange(false)}
          >
            <FormattedMessage
              defaultMessage="Cancel"
              description="Close hiring goals modal without changes"
            />
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
}
export { HiringGoalModal };
